/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBookmarkPlus: {
  name: 'bookmark-plus';
  data: string;
} = {
  name: 'bookmark-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v15.674a2 2 0 0 1-2.55 1.923L12 20.04l-5.45 1.557A2 2 0 0 1 4 19.674V4Zm14 0H6v15.674l5.45-1.557a2 2 0 0 1 1.1 0L18 19.674V4Zm-6 4a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1V9a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
